<!--  -->
<template>
<div class='layout'>
    <iframe :src="cur" frameborder="0"></iframe>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    cur:'',
    links:[
        'https://www.4dkankan.com/spc.html?m=5ViZ0urdOP&lang=zh',
        'https://www.4dkankan.com/spc.html?m=vWRCztw85Z&lang=zh',
        'https://www.4dkankan.com/spc.html?m=Sa4HC4et7g&lang=zh',
        'https://www.4dkankan.com/spc.html?m=2KvlpWd5Ea&lang=zh',
        'https://www.4dkankan.com/spc.html?m=ozAaC699Mw&lang=zh'
    ]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    this.cur = this.links[this.$route.query.id];
}
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .layout {
        width:100%;
        height:100%;
        iframe {
            width:100%;
            height:100%;
        }
    }
</style>